import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RateType } from "../schema/UpdateRoomRateSchema";
import { updateRoomResponseSchema } from "../response/UpdateRoomResponse";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";

export const useUpdateRoomRate = () => {
    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: RateType;
        }) => privateApi.post(`/v4/booking/${values.bookingId}/room-rate`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = updateRoomResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update room rate data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update room rate', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room rate data format");
            } else {
                console.error('Failed to update room rate', error);
                throw error;
            }
        },
    });
};